import type { QuestionLogicModel } from '@webapp/common/resources/entities';
import { LogicTransition } from '@webapp/common/resources/survey';

import type { QuestionActorRef } from '@webapp/survey/src/machine/question-machine';

// Действие квоты хранится в GOAL (в модели вопроса — transition).
// TRANSITION_TYPE — это подтип завершения (текст/редирект/опрос), и он может
// остаться от прежнего действия: например, квоту переключили с
// «дисквалификации» на «скрыть варианты», а transition_type остался TEXT.
// Поэтому действие резолвим из transition, а transitionType — только фолбэк
// для старых данных, где действие могло остаться в подтипе.
export const resolveQuotaAction = (logic: { transition?: number; transitionType?: number }): number =>
    Number(logic.transition) || Number(logic.transitionType);

export const isQuotaHideLogic = (logic: { transition?: number; transitionType?: number }): boolean =>
    resolveQuotaAction(logic) === LogicTransition.ANSWERS_HIDE;

// Ищет логику квоты по id среди всех вопросов: действие в ответе сервиса
// (denied.action) может быть устаревшим, поэтому определяем действие по
// данным самого вопроса.
export const findQuotaLogicById = (
    questions: Array<QuestionActorRef>,
    logicId: number | null | undefined,
): QuestionLogicModel | null => {
    if (logicId === null || logicId === undefined) {
        return null;
    }

    for (const question of questions) {
        const logic = question.getSnapshot().context.logics.find((item) => Number(item.id) === Number(logicId));
        if (logic) {
            return logic;
        }
    }

    return null;
};
